import { render, staticRenderFns } from "./austrian.vue?vue&type=template&id=4c6d6477&scoped=true&"
import script from "./austrian.vue?vue&type=script&lang=js&"
export * from "./austrian.vue?vue&type=script&lang=js&"
import style0 from "./austrian.vue?vue&type=style&index=0&id=4c6d6477&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6d6477",
  null
  
)

export default component.exports